var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 12,
  viewBox: "0 0 18 12",
  fill: "current",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.9791 0.292893C17.3696 0.683417 17.3696 1.31658 16.9791 1.70711L6.97912 11.7071C6.5886 12.0976 5.95543 12.0976 5.56491 11.7071L1.01946 7.16165C0.628931 6.77113 0.628931 6.13796 1.01946 5.74744C1.40998 5.35691 2.04315 5.35691 2.43367 5.74744L6.27202 9.58579L15.5649 0.292893C15.9554 -0.0976311 16.5886 -0.0976311 16.9791 0.292893Z",
  fill: "current"
})));
export { SvgCheck as ReactComponent };
export default __webpack_public_path__ + "static/media/check.98c317c7.svg";